/**
 * Generic Dashlet with a 'TABLE' inside
 */
hrd.AbstractTableDashlet = hrd.AbstractDashlet.extend({
	ROW_PREFIX: 'row_id',
	TABLE_ID: undefined, // will be populated by TableManager
	tableInstance: undefined,
	toBeRefreshed: false,
	init: function(panel, options){
		var defaults = {
			impl: 'hrd.AbstractTableDashlet',
			refreshOnResize: true,
			style: ''
		};
		this._super(panel, $.extend({}, defaults, options));
	},
	doInit: function(){
		this._super();
		this.manager = new hrd.manager.TableManager(this.panel, {
			prefix: this.settings.prefix,
			rowPrefix: this.ROW_PREFIX,
			reference: this
		});
		this.toolbox = new hrd.Toolbox();
	},
	doTable: function(){
		$(this.TAB_ID).on('tab-activated tab-reactivated', function(evt) {
			this.refreshTable({forceUpdate: false});
		}.bind(this));

		if($(this.OUTER_TAB_ID).exists()) {
			$(this.OUTER_TAB_ID).on('tab-activated tab-reactivated', function(evt) {
				this.refreshTable({forceUpdate: false});
			}.bind(this));
		}

		return this.manager.doTable().then(function(tableInstance){
			/* manage of headerless-dashlets but not if inside a tab */
			if(!$(this.HEADER_ID).is(':visible')){
				var myParentIsTab = $(this.PANEL_ID).parent().hasClass('dashlet-tab-pane');
				if(!myParentIsTab){
					$('.dataTables_scroll', this.CONTENT_ID).addClass('ui-corner-top');
				}
			}
			this.tableInstance = tableInstance;
			return $.when(tableInstance);
		}.bind(this));
	},
	doTableOptions: function(){
		var docLabel, filterLabel, options = {};
		// arguments management: docLabel, filterLabel, options
		switch ((arguments.length)) {
			case 1:
				if(typeof arguments[0] === 'object'){
					options = arguments[0]
				} else {
					docLabel  = arguments[0];
				}
				break;
			case 2:
				docLabel = arguments[0];
				if(typeof arguments[1] === 'object'){
					options = arguments[1]
				} else {
					filterLabel  = arguments[1];
				}
				break;
			case 3:
				docLabel = arguments[0];
				filterLabel  = arguments[1];
				options = arguments[2]
				break;
		}
		return {
			docLabel: docLabel,
			filterLabel: filterLabel,
			options: options
		};
	},
	doEditableOptions: function(options){
		return options;
	},
	doAutoFillOptions: function(opts){
		return opts;
	},
	doResize: function(redraw){
		if(this.settings.refreshOnResize) {
			let oSettings = this.tableInstance ? this.tableInstance.fnSettings() : {};
			oSettings.bResizing = true;
			this.resetTableBeforeResize(oSettings);
			let resizeDeferred = $.Deferred();
			oSettings.pResizePromise = resizeDeferred.promise();
			this.refreshTable({
				samePage: true,
				useCache: true
			}).then(() => {
				resizeDeferred.resolve();
				delete oSettings.bResizing;
			});
		}
	},
	/**
	 * Prima del resize, se originariamente la colonna non aveva definito 'sWidth' ('sWidthMissing = true')
	 * vengono nullificati i valori 'sWidthOrig' in modo da far ricalcolare 
	 * le larghezze effettive con il nuovo spazio disponibile, utile in caso di ellipsis.
	 * inoltre viene sbiancato anche 'sWidth' per farlo ricalcolare.
	 */
	resetTableBeforeResize: function(oSettings) {
		if(oSettings && oSettings.aoColumns) {
			oSettings.aoColumns.forEach(column => {
				if(column.sWidthMissing) {
					column.sWidthOrig = null;
					column.sWidth = null;
				}
				// clear some values for a correct width evaluation
				const thStyle = $(column.nTh).get(0).style;

				thStyle.removeProperty('width');
				thStyle.removeProperty('--width');
				thStyle.removeProperty('--min-width');
				thStyle.removeProperty('--max-width');
			});
		}
	},
	isInitialized: function(){
		return this.manager.isInitialized();
	},
	refreshTableAction: function(evt, btn, options){
		return this.refreshTable(options);
	},
	refreshTable: function(options){
		options = options || {};
		var forceUpdate = (options.forceUpdate == undefined) ? (!this.isInsideNotActiveTab()) : options.forceUpdate;
		if (this.isInsideNotActiveTab()){
			this.toBeRefreshed = true;
		} else {
			var p = undefined;
			if(this.toBeRefreshed || forceUpdate){
				p = this.manager.refreshTable(options);
			}
			this.toBeRefreshed = false;
			if(p != undefined){
				return p;
			}
		}
		return $.when();
	},
	exportTableExcelAction: function(evt, btn, options){
		return this.manager.exportExcel(options);
	},
	exportTableCSVAction: function(evt, btn, options){
		return this.manager.exportCSV(options);
	},
	rowFocus: function(nRow){
		this.manager.rowFocus(nRow);
	},
	rowBlur: function(nRow){
		this.manager.rowBlur(nRow);
	},
	getActiveRowId: function(){
		return this.manager.getActiveRowId();
	},
	getActiveRow: function(){
		return this.manager.getActiveRow();
	},
	makeRowActive: function(rowId){
		this.manager.makeRowActive(rowId);
	},
	clearRowActive: function(){
		this.manager.clearRowActive();
	},
	activateRow: function(rowId){
		this.deactivateActiveRow();
		this.clearRowActive();
		this.makeRowActive(rowId);
		this.activateActiveRow();
	},
	/**
	 * Useful for select active row programmatically
	 */
	activateActiveRow: function(){
		this.manager.activateActiveRow();
	},
	/**
	 * Useful for un-select active row programmatically
	 */
	deactivateActiveRow: function(){
		this.manager.deactivateActiveRow();
	},
	getSelectedRowData: function(){
		return this.manager.getSelectedRowData();
	},
	getSelectedRow: function(){
		return this.manager.getSelectedRow();
	},
	getFirstRow: function(){
		return this.manager.getFirstRow();
	},
	getFirstRowByPropertyValue: function(property, value) {
		return this.manager.getFirstRowByPropertyValue(property, value);
	},
	getRowById: function(rowId){
		return this.manager.getRowById(rowId);
	},
	getRowIndexById: function(rowId){
		return this.manager.getRowIndexById(rowId);
	},
	selectTableRowById: function(rowId, applyIgnoreCallback){
		return this.manager.selectTableRowById(rowId, applyIgnoreCallback);
	},
	selectTableRow: function(row, applyIgnoreCallback){
		return this.manager.selectTableRow(row, applyIgnoreCallback);
	},
	makeRowVisible: function(row){
		return this.manager.makeRowVisible(row);
	},
	selectTableRows: function(rowIds, trigger){
		return this.manager.selectTableRows(rowIds, trigger);
	},
	hasSelectedItems: function(){
		return this.manager.hasSelectedItems();
	},
	/**
	 * Return array of selected row 'ids', but only the visible 'page'
	 */
	getSelectedIndexes: function(){
		return this.manager.getSelectedIndexes();
	},
	addSelection: function(rowId, rowData){
		return this.manager.addSelection(rowId, rowData);
	},
	removeSelection: function(rowId){
		return this.manager.removeSelection(rowId);
	},
	/**
	 * Return array of selected row objects, but only the visible 'page'
	 */
	getSelectedData: function(){
		return this.manager.getSelectedData();
	},
	clearSelectedIndexes: function(){
		this.manager.clearSelectedIndexes();
	},
	/**
	 * Method that will filter the table programmatically
	 *
	 */
	filter: function(filterText){
		this.manager.filter(filterText);
	},
	/**
	 * Method that will clear the filter table field
	 *
	 */
	clearFilters: function(redraw){
		this.manager.clearFilters(redraw);
	},
	clearTable: function(redraw){
		this.manager.clearTable(redraw);
	},
	toggleColumnVisibility: function(colName, visible, redraw) {
		this.manager.toggleColumnVisibility(colName, visible, redraw);
	},
	/**
	 * Facility for colouring the background of a row with a given colour.
	 * Moreover the foreground colour will be computed in order to make it visible on that background
	 * @param nTable
	 * @param nRow
	 * @param backgroundColor
	 */
	colorizeRow: function(nRow, bgColor, markerClass) {
		this.manager.colorizeRow(nRow, bgColor, markerClass);
	},
	unColorize: function(markerClass) {
		this.manager.unColorize(markerClass);
	},
	useRecycleBin: function(title, scope, options){
		options = options || {};
		let defaults = {
			title: title,
			scope: scope,
			position: {
				my: "center bottom",
				at: "center top+20",
			}
		};
		options = $.extend(true, {}, defaults, options);
		if(this.recycleBin == undefined){
			this.recycleBin = new hrd.RecycleBin(this.PANEL_ID, options);
		}
		return this.recycleBin.use();
	},
	/**
	 * METODHS Useful for RecordSet Navigator
	 */
	currentRowData: function(index, property = 'id') {
		return this.manager.currentRowData(index, property);
	},
	goToIndex: function(index, property = 'id') {
		return this.manager.goToIndex(index, property);
	},
	firstRowData: function(property = 'id'){
		return this.manager.firstRowData(property);
	},
	prevRowData: function(index, property = 'id') {
		return this.manager.prevRowData(index, property);
	},
	nextRowData: function(index, property = 'id') {
		return this.manager.nextRowData(index, property);
	},
	lastRowData: function(property = 'id'){
		return this.manager.lastRowData(property);
	},
	/*****************************/
});